'use strict';

import moment from 'moment';
import {module} from '../app';
import * as constantStrings from '../constants/constantStrings';

export class DatePickerService {
  static $inject = [
    'ionicDatePicker'
  ];

  constructor(ionicDatePicker) {
    this.ionicDatePicker = ionicDatePicker;
  }

  changeDate(changeDateModel) {
    let {minDate, maxDate} = this.initializeMinMaxDateRange(changeDateModel);

    const {obj, id, idProperty, valueProperty} = changeDateModel;

    const hasIdAndValueProperty = !!idProperty && !!valueProperty;
    let value = null;
    if (hasIdAndValueProperty) {
      const property = obj.find((element) => element[idProperty] === id);
      value = property[valueProperty];
    } else {
      value = obj[id];
    }

    const inputDate = !value || value === '/  /' || value === '//' ? new Date() : new Date(value);

    let ipObj = {
      callback: function (val) {
        let date = new Date(val);
        if (date > maxDate) {
          date = maxDate;
        } else if (date < minDate) {
          date = minDate;
        }

        const parsedValue = moment(date).format('MM/DD/YYYY');

        if (hasIdAndValueProperty) {
          const property = obj.find((element) => element[idProperty] === id);
          property[valueProperty] = parsedValue;
        } else {
          obj[id] = parsedValue;
        }
      },
      inputDate: inputDate,
      from: minDate,
      to: maxDate
    };

    this.ionicDatePicker.openDatePicker(ipObj);
  }

  initializeMinMaxDateRange(changeDateModel) {
    let minDate = changeDateModel.minDate;
    if (!minDate) {
      minDate = new Date(1900, 1, 1);
    }
    let maxDate = changeDateModel.maxDate;
    if (!maxDate) {
      const now = new Date();
      maxDate = new Date(
        now.getFullYear() + constantStrings.MAX_DATE_YEARS_TO_THE_FUTURE, 
        constantStrings.DECEMBER_MONTH_NUMBER, 
        constantStrings.DECEMBER_LAST_DAY);
    }
    return {minDate, maxDate};
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/date-picker.js